import http from '../http'
/* -------------日志处理接口------------------- */
/**
 * 获取日志列表
 * @param {object} search 查询参数, 如: { keyword: '', stime: '开始时间', etime: '结束时间', size: 30, page: 1 }
 */
export const getLogs = search => {
    return http.get('/api/logs', { params: search })
}
/**
 * 导出日志
 * @param {object} search 查询参数, 如: { keyword: '', stime: '开始时间', etime: '结束时间' }
 */
export const exportLogs = search => {
    return http.get('/api/logs/data', { params: search, responseType: 'blob' })
}
/**
 * 批量删除日志
 * @param {array} ids 日志id集合, 例: [1,2,3,4]
 */
export const deleteLogs = ids => {
    return http.delete('/api/logs', { data: ids })
}



// WEBPACK FOOTER //
// ./src/api/main/api-logs.js